import { killSessionTerminal } from '../../../hooks/useTerminalExecution';
import type { TerminalTab } from '../../../store/terminalStore';

export async function closeTerminalTabProcess(
  tab: Pick<TerminalTab, 'sessionId' | 'ptyId'>,
): Promise<void> {
  if (tab.ptyId) {
    await window.electronAPI?.pty?.close(tab.ptyId);

    return;
  }

  await killSessionTerminal(tab.sessionId);
}
